/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.50.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ForbiddenErrorResponse,
  GetOrganizationParams,
  GetOrganizationsParams,
  Id,
  Organization,
  UnauthorizedErrorResponse,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

/**
 * @summary Get organizations
 */
export const getOrganizations = (
  tenantId: Id,
  params: GetOrganizationsParams,
  signal?: AbortSignal
) => {
  return httpClient<Organization[]>({
    url: `/query-service/tenant/${tenantId}/organization-information/get-organizations`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOrganizationsQueryKey = (
  tenantId?: Id,
  params?: GetOrganizationsParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "organization-information",
    "get-organizations",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizations>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationsQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrganizations>>
  > = ({ signal }) => getOrganizations(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganizations>>
>;
export type GetOrganizationsQueryError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizations>>,
          TError,
          Awaited<ReturnType<typeof getOrganizations>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get organizations
 */

export function useGetOrganizations<
  TData = Awaited<ReturnType<typeof getOrganizations>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganizations>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrganizationsQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get organization
 */
export const getOrganization = (
  tenantId: Id,
  params: GetOrganizationParams,
  signal?: AbortSignal
) => {
  return httpClient<Organization>({
    url: `/query-service/tenant/${tenantId}/organization-information/get-organization`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetOrganizationQueryKey = (
  tenantId?: Id,
  params?: GetOrganizationParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "organization-information",
    "get-organization",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrganizationQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
    signal,
  }) => getOrganization(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get organization
 */

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetOrganizationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrganizationQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
